import {
  VehicleModel,
  NavigationGuide,
  QsgV1Model,
  SectionModel,
  DisclaimerFeatureModel,
  GetQsgSearchResultsResponse,
} from '../../../fetch-data/graphql/types';

export enum QSGActions {
  SET_AVAILABLE_QSG_MODELS = 'SET_AVAILABLE_QSG_MODELS',
  SET_QSG_NAVIGATION = 'SET_QSG_NAVIGATION',
  SET_QSG_CONTENT = 'SET_QSG_CONTENT',
  SET_SELECTED_QSG_MODEL = 'SET_SELECTED_QSG_MODEL',
  RESET_QSG_MODEL_SELECTION = 'RESET_QSG_MODEL_SELECTION',
  SET_NOTIFICATION_MESSAGE = 'SET_NOTIFICATION_MESSAGE',
  SET_QSG_SECTION = 'SET_QSG_SECTION',
  SET_QSG_SECTION_MAP = 'SET_QSG_SECTION_MAP',
  SET_QSG_SECTION_LOADING = 'SET_QSG_SECTION_LOADING',
  SET_QSG_SECTION_ERROR = 'SET_QSG_SECTION_ERROR',
  RESET_QSG_DATA = 'RESET_QSG_DATA',
  SET_ALL_DISCLAIMERS = 'SET_ALL_DISCLAIMERS',
  SET_QSG_SEARCH_TERM = 'SET_QSG_SEARCH_TERM',
  SET_QSG_SEARCH_PAGE = 'SET_QSG_SEARCH_PAGE',
  SET_QSG_SEARCH_RESULTS = 'SET_QSG_SEARCH_RESULTS',
  SET_QSG_SEARCH_LOADING = 'SET_QSG_SEARCH_LOADING',
  SET_QSG_SEARCH_ERROR = 'SET_QSG_SEARCH_ERROR',
  RESET_QSG_SEARCH = 'RESET_QSG_SEARCH',
  SET_SSR_HISTORY = 'SET_SSR_HISTORY',
}

export const setAvailableQsgModels = (models: VehicleModel[]) => ({
  type: QSGActions.SET_AVAILABLE_QSG_MODELS,
  payload: models,
});

export const setQsgNavigation = (navigation: NavigationGuide) => ({
  type: QSGActions.SET_QSG_NAVIGATION,
  payload: navigation,
});

export const setQsgContent = (qsg: QsgV1Model) => ({
  type: QSGActions.SET_QSG_CONTENT,
  payload: qsg,
});

export const setSelectedQsgModel = (model: Partial<VehicleModel>) => ({
  type: QSGActions.SET_SELECTED_QSG_MODEL,
  payload: model,
});

export const setQsgSection = (section: SectionModel) => ({
  type: QSGActions.SET_QSG_SECTION,
  payload: section,
});

export const setQsgSectionMap = (sectionMap: Record<string, SectionModel>) => ({
  type: QSGActions.SET_QSG_SECTION_MAP,
  payload: sectionMap,
});

export const resetQsgModelSelection = () => ({
  type: QSGActions.RESET_QSG_MODEL_SELECTION,
});

export const setNotificationMessage = (message: string) => ({
  type: QSGActions.SET_NOTIFICATION_MESSAGE,
  payload: message,
});

export const setQsgSectionLoading = (
  sectionId: string,
  isLoading: boolean
) => ({
  type: QSGActions.SET_QSG_SECTION_LOADING,
  payload: { sectionId, isLoading },
});

export const setQsgSectionError = (
  sectionId: string,
  error: string | null
) => ({
  type: QSGActions.SET_QSG_SECTION_ERROR,
  payload: { sectionId, error },
});

export const resetQsgData = () => ({
  type: QSGActions.RESET_QSG_DATA,
});

export const setAllDisclaimers = (disclaimers: DisclaimerFeatureModel[]) => ({
  type: QSGActions.SET_ALL_DISCLAIMERS,
  payload: disclaimers,
});

export const setQsgSearchTerm = (searchTerm: string) => ({
  type: QSGActions.SET_QSG_SEARCH_TERM,
  payload: searchTerm,
});

export const setQsgSearchPage = (page: number) => ({
  type: QSGActions.SET_QSG_SEARCH_PAGE,
  payload: page,
});

export const resetQsgSearch = () => ({
  type: QSGActions.RESET_QSG_SEARCH,
});

export const setQsgSearchResults = (
  searchKey: string,
  results: GetQsgSearchResultsResponse
) => ({
  type: QSGActions.SET_QSG_SEARCH_RESULTS,
  payload: { searchKey, results },
});

export const setQsgSearchLoading = (searchKey: string, isLoading: boolean) => ({
  type: QSGActions.SET_QSG_SEARCH_LOADING,
  payload: { searchKey, isLoading },
});

export const setQsgSearchError = (searchKey: string, error: string | null) => ({
  type: QSGActions.SET_QSG_SEARCH_ERROR,
  payload: { searchKey, error },
});

export const setSsrHistory = (history: {
  pathname: string;
  search: string;
  hash: string;
  serverRequestUrl?: string;
  headers?: Record<string, string | string[] | undefined>;
}) => ({
  type: QSGActions.SET_SSR_HISTORY,
  payload: history,
});
